import { createAuthClient } from "better-auth/client";

/** better-auth talks to /api/auth/* on this same origin; cookies ride along. */
export const authClient = createAuthClient();
